import { useEffect, useRef, useState } from 'react';

import { Card } from '@zillow/constellation-10';

// Components
import Carousel from 'app/shared/components/Carousel';

import getTiles from './Items';

import type React from 'react';
import type { CardRootPropsInterface } from '@zillow/constellation-10';

const UpsellCarouselModule: React.FunctionComponent<
  React.PropsWithChildren<
    React.PropsWithChildren<CardRootPropsInterface> & { addMarginTop?: boolean; addMarginBottom?: boolean }
  >
> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  const AUTO_SCROLL_SPEED = 10 * 1000;
  const AUTO_SCROLL_PAUSE_DURATION = 30 * 1000;

  const updateWidth = () => {
    const containerObj = (containerRef && containerRef.current) || {
      offsetWidth: 1220,
    };

    setWidth(containerObj.offsetWidth);
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  const ZrmUpsellItems = getTiles();

  return (
    <Card
      tone="neutral"
      ref={containerRef}
      css={{
        width: '100%',
        padding: 0,
        marginTop: props.addMarginTop ? '800' : undefined,
        marginBottom: props.addMarginBottom ? '400' : undefined,
      }}
      {...props}
    >
      <Carousel
        width={width}
        items={ZrmUpsellItems}
        autoScrollSpeed={AUTO_SCROLL_SPEED}
        autoScrollPauseDuration={AUTO_SCROLL_PAUSE_DURATION}
      />
    </Card>
  );
};

export default UpsellCarouselModule;
